import { atom } from 'nanostores';

/**
 * @typedef {object} MessageGlobalStore
 * @property {import('nanostores').WritableAtom<boolean>} messageGlobalOpen
 */

/** @type {Map<string, MessageGlobalStore>} */
const registry = new Map();

function createMessageGlobalStore() {
  if (!window?.process?.NODE_ENV) {
    console.warn('There is no NODE_ENV present, which is a requirement for nanostores. Consider installing the process package: https://www.npmjs.com/package/process');
    window.process = {
      ...(window.process ?? {}),
      env: { ...(window.process?.env ?? {}), NODE_ENV: 'production' },
    };
  }
  return { messageGlobalOpen: atom(false) };
}

/**
 * Get-or-create the store instance for an ID.
 * @param {string} [id]
 * @returns {MessageGlobalStore}
 */
export function getMessageGlobalStore(id = 'default') {
  let store = registry.get(id);
  if (!store) {
    store = createMessageGlobalStore();
    registry.set(id, store);
  }
  return store;
}

/**
 * Destroy a store instance. Call at the START of a Storybook decorator so
 * each story starts from a clean slate.
 * @param {string} id
 */
export function destroyMessageGlobalStore(id) {
  registry.delete(id);
}

/** @param {string} [id] */
export function showMessageGlobal(id = 'default') {
  const { messageGlobalOpen } = getMessageGlobalStore(id);
  messageGlobalOpen.set(true);
}

/** @param {string} [id] */
export function hideMessageGlobal(id = 'default') {
  const { messageGlobalOpen } = getMessageGlobalStore(id);
  messageGlobalOpen.set(false);
}
